import moment from 'moment';
export const createDefaultRecurrence = () => ({
    intervalWeeks: 1,
    endDate: null,
});
// Matches the backend limit on how far a recurring absence may run
export const getMaxRecurrenceEndDate = (startDate) => moment.utc(startDate).add(1, 'year');
export const isRecurrenceEndDateValid = (recurrence, startDate) => {
    if (!recurrence.endDate || !startDate)
        return false;
    const endDate = moment.utc(recurrence.endDate);
    return (!endDate.isBefore(moment.utc(startDate), 'day') &&
        !endDate.isAfter(getMaxRecurrenceEndDate(startDate), 'day'));
};
export const isRecurrenceValid = (recurrence, startDate) => recurrence.intervalWeeks >= 1 && isRecurrenceEndDateValid(recurrence, startDate);
